import { createPageApp } from '@/lib/createPageApp'
import AttestationDescriptionPage from './AttestationDescriptionPage.vue'

createPageApp(AttestationDescriptionPage).mount()
